/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Ship } from './Ship';
import {
    ShipFromJSON,
    ShipFromJSONTyped,
    ShipToJSON,
} from './Ship';

/**
 * 
 * @export
 * @interface ShipRegisterGet200Response
 */
export interface ShipRegisterGet200Response {
    /**
     * 
     * @type {Array<Ship>}
     * @memberof ShipRegisterGet200Response
     */
    records?: Array<Ship>;
}

/**
 * Check if a given object implements the ShipRegisterGet200Response interface.
 */
export function instanceOfShipRegisterGet200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShipRegisterGet200ResponseFromJSON(json: any): ShipRegisterGet200Response {
    return ShipRegisterGet200ResponseFromJSONTyped(json, false);
}

export function ShipRegisterGet200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipRegisterGet200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(ShipFromJSON)),
    };
}

export function ShipRegisterGet200ResponseToJSON(value?: ShipRegisterGet200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(ShipToJSON)),
    };
}

